export default function PageHeader({ overline, title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div>
        {overline && (
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-2 font-heading">
            {overline}
          </div>
        )}
        <h1 className="text-3xl sm:text-4xl tracking-tight font-light font-heading">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-2 font-body">{subtitle}</p>}
      </div>
      {children && <div className="flex gap-2">{children}</div>}
    </div>
  );
}
